module.exports = __webpack_public_path__ + "img/icon3.a07c1b3e.svg";